/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Starter_9Inputs */



/**
* | output |
* | --- |
* | "Access to browser-based editor" |
*
* @param {Signup_Feature_Starter_9Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_starter_9 = /** @type {((inputs?: Signup_Feature_Starter_9Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Starter_9Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Access to browser-based editor")
	if (locale === "de") return /** @type {LocalizedString} */ ("Access to browser-based editor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Access to browser-based editor")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Access to browser-based editor")
	if (locale === "es") return /** @type {LocalizedString} */ ("Access to browser-based editor")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Access to browser-based editor")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Access to browser-based editor")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Access to browser-based editor")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Access to browser-based editor")
	return /** @type {LocalizedString} */ ("Access to browser-based editor")
});